import { groq } from 'next-sanity'
import { flexibleContent, seoFields } from '../partials/shared'

export const productsBySlugQuery = groq`*[_type == "productPages" && slug.current == $slug][0] {
	_id,
	_type,
	slug,
	title,
  headline,
  subHeadline,
  headlineSVG->{
		svg,
		title,
		_type
	},
	${flexibleContent}
  ${seoFields}
}`

export const productsBySlugSeoQuery = groq`*[_type == "productPages" && slug.current == $slug][0]{
	${seoFields}
}`
